import { render, staticRenderFns } from "./client-dialog.vue?vue&type=template&id=20f334e8&scoped=true"
import script from "./client-dialog.vue?vue&type=script&lang=js"
export * from "./client-dialog.vue?vue&type=script&lang=js"
import style0 from "./client-dialog.vue?vue&type=style&index=0&id=20f334e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f334e8",
  null
  
)

export default component.exports